module.exports = __webpack_public_path__ + "static/googlecloud-e4d2873b0a1ada7bf4e9c4b035ca87e6.png";